/* @license
 *
 * © 2022 Daniel Aleksandersen <https://www.daniel.priv.no/>
 * SPDX-License-Identifier: CC0-1.0
 */
(function(w, d) {
  function replaceTextNode(n, t)
  {
    if (!n)
    {
      return;
    }
    n.replaceChild(d.createTextNode(t), n.childNodes[0]);
  }
  function zeroPad(num)
  {
    return num < 10 ? '0' + num : '' + num;
  }
  (function() {
    var times = d.querySelectorAll('.dt-published,.dt-updated');
    if (!times)
    {
      return;
    }
    [].forEach.call(times, function(time) {
      if (time.dateTime)
      {
        var dt = new Date(Date.parse(time.dateTime));
        replaceTextNode(time, `${dt.getFullYear()}-${zeroPad(dt.getMonth() + 1)}-${zeroPad(dt.getDate())}`);
      }
    });
  })();
  function openAddToAnyWindow(ev)
  {
    var popup = window.open(
      'about:blank',
      null,
      `height=560,width=760,top=${parseInt((screen.height / 2) - 200)},left=${parseInt((screen.width / 2) - 400)}`
    );
    if (popup)
    {
      popup.document.title = 'Loading …';
      popup.opener = null;
      popup.location.replace(d.querySelector('.entry-buttns .wbshare .bttn').href);
      ev.preventDefault();
    }
    var webShareDialog = d.getElementById('webshare-dialog');
    if (webShareDialog && webShareDialog.open)
    {
      webShareDialog.close();
    }
  }
  function webShareFallback(ev)
  {
    if (ev && ev.preventDefault)
    {
      ev.preventDefault();
    }
    var webShareButton = d.querySelector('.entry-buttns .wbshare .bttn'),
        webShareDialog = d.getElementById('webshare-dialog'),
        innerDialog = webShareDialog && webShareDialog.querySelector('& > div');
    if (!webShareDialog)
    {
      webShareDialog = d.createElement('dialog');
      webShareDialog.id = 'webshare-dialog';
      webShareDialog.onmousedown = (_) => { _.target === webShareDialog && webShareDialog.close()};
      innerDialog = d.createElement('div');
      webShareDialog.appendChild(innerDialog);
      var closeButton = d.createElement('button');
      closeButton.addEventListener('click', (ev) =>
        {
          if (webShareDialog.open)
          {
            webShareDialog.close();
          }
          else
          {
            webShareDialog.style.display = 'none';
          }
        }
      );
      closeButton.classList.add('bttn', 'dialog-close');
      innerDialog.appendChild(closeButton);
      var inputLabel = d.createElement('label'),
          inputGroup = d.createElement('span'),
          inputField = d.createElement('input'),
          inputButton = d.createElement('button');
      inputLabel.classList.add('webshare-urlinput-label');
      inputLabel.setAttribute('for', 'webshare-urlinput-field');
      inputLabel.appendChild(d.createTextNode('Copy the address and share it: '));
      innerDialog.appendChild(inputLabel);
      inputField.id = 'webshare-urlinput-field';
      inputField.type = 'url';
      inputField.readOnly = 'readonly';
      inputField.value = `${d.querySelector('link[rel~=canonical]').href || d.location.href}#src=sharebox`;
      inputField.addEventListener('focus', (ev) => { inputField.select(); });
      inputField.addEventListener('click', (ev) => { inputField.select(); });
      inputGroup.classList.add('webshare-urlinput-controllers')
      inputGroup.appendChild(inputField);
      if (navigator.clipboard)
      {
        inputButton.classList.add('bttn');
        inputButton.appendChild(d.createTextNode('Copy'));
        inputButton.addEventListener('click', () =>
          {
            navigator.clipboard.writeText(inputField.value).then(
              (ev) => {
                inputField.select();
                inputButton.replaceChildren(d.createTextNode('Copied'));
              },
              (ev) => { inputButton.replaceChildren(d.createTextNode('Failed')); }
            );
          }
        );
        inputGroup.appendChild(inputButton);
      }
      innerDialog.appendChild(inputGroup);
      var addToAnyLabel = d.createElement('label'),
          addToAnyButton = d.createElement('a');
      addToAnyLabel.classList.add('webshare-addtoany');
      addToAnyLabel.appendChild(d.createTextNode('Or share to popular apps through: '));
      addToAnyButton.classList.add('bttn', 'icon-addtoany');
      addToAnyButton.rel = 'nofollow noopener';
      addToAnyButton.target = '_blank';
      addToAnyButton.href = d.querySelector('.entry-buttns .wbshare .bttn.icon-share').href;
      addToAnyButton.addEventListener('click', openAddToAnyWindow);
      addToAnyButton.appendChild(d.createTextNode('AddToAny'));
      addToAnyLabel.appendChild(addToAnyButton);
      innerDialog.appendChild(addToAnyLabel);
      webShareButton.after(webShareDialog);
    }
    if (webShareDialog.showModal)
    {
      webShareDialog.showModal();
    }
    else
    {
      innerDialog.style.boxShadow = '0 0 0 5000px #000d';
      webShareDialog.style.display = 'block';
      innerDialog.style.posiotion = 'absolute';
      innerDialog.style.zIndex = '1';
    }
    d.getElementById('webshare-urlinput-field').focus();
  }
  function handleWebShareAction(ev)
  {
    ev.preventDefault();
    navigator.share(
      {
        title: d.querySelector('meta[name=title]').content || d.title,
        url: `${d.querySelector('link[rel~=canonical]').href || d.location.href}#src=webshare`
      }
    ).catch(webShareFallback);
  }
  var webShareButton = d.querySelector('.entry-buttns .wbshare .bttn');
  if (webShareButton)
  {
    if (navigator.share)
    {
      webShareButton.addEventListener('click', handleWebShareAction);
    }
    else
    {
      webShareButton.addEventListener('click', webShareFallback);
    }
  }
  function toggleArticleSourceList(st)
  {
    var i = 0;
    [].forEach.call(d.querySelectorAll('.entry-sources > ul li'), function(source) {
      if (i >= 3) {
        if (!st)
        {
          source.id = `collapsed-article-source-${i}`;
          source.hidden = 'until-found';
          source.addEventListener('beforematch', (ev) => { toggleArticleSourceList(true); });
        }
        else
        {
          source.removeAttribute('hidden');
        }
      }
      i ++;
    });
    return i;
  }
  (function() {
    var source_list = d.querySelector('.entry-sources > ul');
    var source_list_overflow = 3;
    if (source_list && source_list.children.length >= (source_list_overflow + 3)) {
      var sR = toggleArticleSourceList(false) - source_list_overflow;
      var show_more_item = d.createElement('li'),
          show_more_link = d.createElement('a');
      show_more_link.onclick = function(ev) {
        ev.preventDefault();
        ev.target.parentElement.parentElement.removeChild(ev.target.parentElement);
        toggleArticleSourceList(true);
      }
      show_more_link.href = '#';
      show_more_item.classList.add('show-more-sources');
      show_more_link.appendChild(d.createTextNode(`Show ${sR} more sources`));
      show_more_link.setAttribute('aria-expanded', 'false');
      var aria_controls = Array.from(source_list.querySelectorAll('li[hidden][id]')).flatMap((li) => { return li.id; }).join(' ');
      show_more_link.setAttribute('aria-controls', aria_controls);
      show_more_item.appendChild(show_more_link);
      source_list.insertBefore(show_more_item, source_list.children[source_list_overflow]);
    }
  })();
  (function () {
    var comment_bttn = document.getElementById('comment-bttn');
    if (comment_bttn)
    {
      var api_call = `${comment_bttn.href}?api=count`;
      fetch(api_call, {'importance': 'low'}).then(
        function(response)
        {
          if (response.ok)
          {
            return response.json();
          }
          throw new Error();
        }
      ).then(
        function(api_response)
        {
           var comment_count = api_response['comments'];
           if (comment_bttn && comment_count > 0)
           {
             var comment_str = comment_count >= 2 ? 'comments' : 'comment';
             comment_bttn.innerHTML = `Read <span property="schema:commentCount">${comment_count}</span> ${comment_str}`;
           }
        }
      );
    }
  })();
  function trackRecommendationClickSources(template, src)
  {
    var recommendation_list = template.content.querySelectorAll('.entrylist article a');
    if (!recommendation_list)
    {
      return;
    }
    [].forEach.call(recommendation_list, function(recommendation) {
      recommendation.addEventListener('click', function(ev) {
        ev.currentTarget.href = `${ev.currentTarget.href.split('#')[0]}#src=${src}`;
      });
    });
  }
  (function() {
    var fallback_cards = '../api/related/latest.html',
        cards = `../api/related${new URL(d.querySelector('link[rel~=canonical]').href).pathname}`,
        click_src = 'rel',
        rnd = Math.random();
    if (d.querySelector('.time-outdated') || rnd <= 0.075)
    {
      cards = fallback_cards;
      click_src = 'relnew';
    }
    else if (rnd <= 0.15 && rnd > 0.075)
    {
      var topics = Array.from(document.querySelectorAll('.entry-footer-topics li a[rel=tag]')).slice(0,3).map((link) => { return new URL(link.href).pathname; } );
      if (topics)
      {
        topics.push(topics[0]);  // weight in favor of first tag
        var topic = topics[Math.floor(Math.random() * topics.length)];
        cards = `../api/related${topic}`;
        click_src = 'reltag';
      }
    }
    fetch(cards, {priority:'low'}).then(
      function (response)
      {
        if (response.ok)
        {
          return response.text();
        }
        throw new Error();
      }
    ).catch(
      function()
      {
        if (cards != fallback_cards)
        {
          click_src = 'relfb';
          return fetch(fallback_cards, {priority:'low'}).then(
            function (response)
            {
              if (response.ok)
              {
                return response.text();
              }
            }
          );
        }
      }
    ).then(
      function (text)
      {
        if (text)
        {
          var template = d.createElement('template');
          template.innerHTML = text;
          if (click_src != 'rel')
          {
            var is_same = template.content.querySelector(`link[rel~=bookmark][href="${d.querySelector('link[rel~=canonical]').href}"]`);
            if (is_same)
            {
              is_same.closest('article').remove();
            }
          }
          trackRecommendationClickSources(template, click_src);
          var container = d.getElementById('related');
          if (container)
          {
            container.parentNode.replaceChild(template.content, container);
          }
        }
      }
    );
  })();
})(window, document);